import { render } from "./QuestionClusterEdit.vue?vue&type=template&id=22d01f62"
import script from "./QuestionClusterEdit.vue?vue&type=script&lang=js"
export * from "./QuestionClusterEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__